<template>
  <div
    :class="{
      SearchBox: true,
      hidden:
        $store.state.ui.mode === 'no-map' ||
        $store.state.ui.mode === 'no-years' ||
        $store.state.ui.mode === 'year-highlight' ||
        $store.state.ui.mode === 'highlight-flip',
      'book-view': $store.state.ui.mode === 'book-view',
      highlight: $store.state.ui.mode === 'highlight-location'
    }"
  >
    <input
      :class="{ search: true, inactive: !active }"
      placeholder="Address or business name"
      @input="change"
      @keydown="e => e.stopPropagation()"
      ref="input"
    />

    <div
      @click="activate"
      :class="{
        start: true,
        nbutton: true,
        disabled: $route.name === 'narrative',
        highlighted: $store.state.ui.mode === 'highlight-location'
      }"
    >
      <div>Location Search</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
      >
        <path
          fill="white"
          d="M13.767 12.675l-3.433-3.438c1.726-2.246 1.554-5.492-.518-7.547C8.685.557 7.226 0 5.75 0 4.273 0 2.814.557 1.683 1.69c-2.244 2.247-2.244 5.895 0 8.142 1.132 1.133 2.59 1.69 4.067 1.69 1.227 0 2.455-.384 3.472-1.172l3.452 3.42c.154.153.345.23.556.23.192 0 .403-.077.556-.23.288-.288.288-.788-.019-1.095zM5.768 9.967c-1.131 0-2.168-.442-2.973-1.229-1.63-1.632-1.63-4.3 0-5.953.787-.787 1.842-1.229 2.973-1.229 1.132 0 2.168.442 2.973 1.23.806.787 1.228 1.843 1.228 2.976s-.442 2.17-1.228 2.976c-.786.807-1.86 1.23-2.973 1.23z"
        />
      </svg>
    </div>

    <div
      :class="{
        results: true,
        hidden: !active || $refs.input.value.length < 4
      }"
    >
      <section>
        <div class="suggestion-section-header">On Sunset Blvd</div>
        <div v-if="suggestionsOnSunset.length">
          <div
            class="suggestion nearby"
            v-for="s in suggestionsOnSunset"
            :key="s.id"
            @click="goToSuggestion(s)"
          >
            <span>{{ getSuggestionLabel(s) }}</span>
          </div>
        </div>
        <div class="no-results" v-else>No Results Found</div>
      </section>
      <section>
        <div class="suggestion-section-header">Not on Sunset Blvd</div>
        <div class="suggestion-section-description">
          Takes you to nearest spot on Sunset
        </div>
        <div v-if="suggestionsOffSunset.length">
          <div
            class="suggestion"
            v-for="s in suggestionsOffSunset"
            :key="s.id"
            @click="goToSuggestion(s)"
          >
            <span>{{ getSuggestionLabel(s) }}</span>
          </div>
        </div>
        <div class="no-results" v-else>No Results Found</div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBox",
  data() {
    return {
      active: false
    };
  },
  methods: {
    activate() {
      if (this.$route.name === "narrative") return;
      this.active = !this.active;
      this.$refs.input.focus();

      // If we're on this step of the tour, move tour box to the left as the
      // search input expands
      const tourStep = document.querySelector(".v-step");
      if (tourStep) {
        tourStep.style.transition = "left .5s";
        tourStep.style.left = -252 + "px";
      }
    },
    change(e) {
      let v = e.target.value;

      if (v.length <= 3) {
        this.$store.commit("setSearchResults", []);
      } else {
        this.$gtag.event("address_search", {
          event_category: "Map Search",
          event_label: v
        });
        this.$store.dispatch("geocode", { value: v });
      }
    },
    goToSuggestion(s) {
      // If we're on the wrong side of the street, flip
      const currentSide = this.$store.state.geolocation.flipped
        ? "south"
        : "north";
      if (s.side !== currentSide) {
        this.$store.dispatch("flip");
      }

      this.$gtag.event("address_select", {
        event_category: "Map Search",
        event_label: s.text
      });
      this.$store.dispatch("goToLocation", { target: s.closestPosition });
      this.$store.commit("setSearchResults", []);
      this.active = false;
      this.$refs.input.value = "";
    },

    getSuggestionLabel(suggestion) {
      // Get more details for address results
      if (suggestion.place_type[0] === "address" && suggestion.place_name) {
        return suggestion.place_name.split(",")[0];
      }
      return (
        suggestion.text +
        (suggestion.properties.address
          ? " (" + suggestion.properties.address + ")"
          : "")
      );
    }
  },
  computed: {
    suggestions() {
      return this.$store.state.geolocation.searchResults;
    },

    suggestionsOnSunset() {
      return this.suggestions.filter(({ distance }) => distance < 0.25);
    },

    suggestionsOffSunset() {
      return this.suggestions.filter(({ distance }) => distance >= 0.25);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.SearchBox {
  display: flex;
  justify-content: flex-end;

  &.hidden {
    opacity: 0;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  &.book-view {
    .start {
      background: black;
      color: white;

      &:hover {
        background-color: $light-gold;
        color: $copper;
      }
    }
  }
}

.start {
  text-transform: uppercase;
  display: flex;
  align-items: center;

  &.disabled {
    cursor: default;
  }
}

.highlight .start {
  background-color: $light-gold;
  color: $copper;
}

input {
  transition: 0.5s;
  opacity: 1;
  height: 30px;
  font-size: 14px;
  border: none;
  padding-left: 7px;
  width: 252px;
  font-family: "Graphik";
  font-weight: 400;

  @media (max-width: 815px) and (orientation: portrait) {
    width: 180px;
  }

  &.inactive {
    padding: 0;
    opacity: 0;
    width: 0px;
  }

  &::placeholder {
    border: 0px;
    color: $brown-grey;
  }
}

.results {
  border-top: 1px solid black;
  background-color: $white;
  position: absolute;
  width: 100%;
  z-index: 1000;
  font-size: 14px;
  top: 30px;

  &.hidden {
    display: none;
  }

  section {
    margin: 0.75em 0;
  }

  .suggestion-section-header {
    color: $copper;
    font-weight: 600;
    padding: 0 0.5em;
    text-align: left;
    text-transform: uppercase;
  }

  .suggestion-section-description {
    color: $brown-grey;
    font-style: italic;
    margin-bottom: 0.25em;
    padding: 0 0.5em;
    text-align: left;
  }

  .no-results {
    color: #707070;
    font-style: italic;
    padding: 0.25em 0.5em;
    text-align: left;
  }

  .suggestion {
    cursor: pointer;
    padding: 0.25em 0.5em;
    text-align: left;

    &:hover {
      background-color: $light-gold;
    }
  }
}
</style>
